export const Lists = {
    ABOUT_US: "AboutUs",
    CONTACT_US: "ContactUs",
    CONTACT_US_FORM: "ContactUsForm",
    CONTACT_ATTACHMENTS: "Contact Attachments",
    THANKYOU_DIALOG: "ThankyouDialog",
    SERVICES: "Services",
    SERVICES_DETAILS: "ServiceDetails",
    PRODUCTS: "Products",
    PRODUCTS_DETAILS: "ProductDetails",
    TERMS_AND_CONDITIONS: "TermsAndConditions",
    PRIVACY_POLICY: "PrivacyPolicy",
    FAQS: "FAQs",
    TECHNOLOGIES: "Technologies",
    SITEMAP: "Sitemap",
    PRODUCT_SIDEBAR_MENU: "ProductSideBarMenu",
};

export const GOOGLE_RE_CAPTCHA_V3_KEY = '6Lfdm0wqAAAAAEBv1RnZbdfLgfroP2hm3tv_dbAV';
export const GOOGLE_RECAPTCHA_V2_KEY = '6Lcdq0wqAAAAAKEqctGdtqYNJwXdRx2m8_L5kxFR';

// export const Countries = [
//     {
//         "name": "Afghanistan",
//         "code": "AF",
//         "flag": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg"
//     },
//     {
//         "name": "Åland Islands",
//         "code": "AX",
//         "flag": "https://flagcdn.com/ax.svg"
//     },
//     {
//         "name": "Albania",
//         "code": "AL",
//         "flag": "https://flagcdn.com/al.svg"
//     },
//     {
//         "name": "Algeria",
//         "code": "DZ",
//         "flag": "https://flagcdn.com/dz.svg"
//     },
//     {
//         "name": "American Samoa",
//         "code": "AS",
//         "flag": "https://flagcdn.com/as.svg"
//     },
//     {
//         "name": "Andorra",
//         "code": "AD",
//         "flag": "https://flagcdn.com/ad.svg"
//     },
//     {
//         "name": "Angola",
//         "code": "AO",
//         "flag": "https://flagcdn.com/ao.svg"
//     },
//     {
//         "name": "Anguilla",
//         "code": "AI",
//         "flag": "https://flagcdn.com/ai.svg"
//     },
//     {
//         "name": "Antarctica",
//         "code": "AQ",
//         "flag": "https://flagcdn.com/aq.svg"
//     },
//     {
//         "name": "Antigua and Barbuda",
//         "code": "AG",
//         "flag": "https://flagcdn.com/ag.svg"
//     },
//     {
//         "name": "Argentina",
//         "code": "AR",
//         "flag": "https://flagcdn.com/ar.svg"
//     },
//     {
//         "name": "Armenia",
//         "code": "AM",
//         "flag": "https://flagcdn.com/am.svg"
//     },
//     {
//         "name": "Aruba",
//         "code": "AW",
//         "flag": "https://flagcdn.com/aw.svg"
//     },
//     {
//         "name": "Australia",
//         "code": "AU",
//         "flag": "https://flagcdn.com/au.svg"
//     },
//     {
//         "name": "Austria",
//         "code": "AT",
//         "flag": "https://flagcdn.com/at.svg"
//     },
//     {
//         "name": "Azerbaijan",
//         "code": "AZ",
//         "flag": "https://flagcdn.com/az.svg"
//     },
//     {
//         "name": "Bahamas",
//         "code": "BS",
//         "flag": "https://flagcdn.com/bs.svg"
//     },
//     {
//         "name": "Bahrain",
//         "code": "BH",
//         "flag": "https://flagcdn.com/bh.svg"
//     },
//     {
//         "name": "Bangladesh",
//         "code": "BD",
//         "flag": "https://flagcdn.com/bd.svg"
//     },
//     {
//         "name": "Barbados",
//         "code": "BB",
//         "flag": "https://flagcdn.com/bb.svg"
//     },
//     {
//         "name": "Belarus",
//         "code": "BY",
//         "flag": "https://flagcdn.com/by.svg"
//     },
//     {
//         "name": "Belgium",
//         "code": "BE",
//         "flag": "https://flagcdn.com/be.svg"
//     },
//     {
//         "name": "Belize",
//         "code": "BZ",
//         "flag": "https://flagcdn.com/bz.svg"
//     },
//     {
//         "name": "Benin",
//         "code": "BJ",
//         "flag": "https://flagcdn.com/bj.svg"
//     },
//     {
//         "name": "Bermuda",
//         "code": "BM",
//         "flag": "https://flagcdn.com/bm.svg"
//     },
//     {
//         "name": "Bhutan",
//         "code": "BT",
//         "flag": "https://flagcdn.com/bt.svg"
//     },
//     {
//         "name": "Bolivia",
//         "code": "BO",
//         "flag": "https://flagcdn.com/bo.svg"
//     },
//     {
//         "name": "Bosnia and Herzegovina",
//         "code": "BA",
//         "flag": "https://flagcdn.com/ba.svg"
//     },
//     {
//         "name": "Botswana",
//         "code": "BW",
//         "flag": "https://flagcdn.com/bw.svg"
//     },
//     {
//         "name": "Bouvet Island",
//         "code": "BV",
//         "flag": "https://flagcdn.com/bv.svg"
//     },
//     {
//         "name": "Brazil",
//         "code": "BR",
//         "flag": "https://flagcdn.com/br.svg"
//     },
//     {
//         "name": "British Indian Ocean Territory",
//         "code": "IO",
//         "flag": "https://flagcdn.com/io.svg"
//     },
//     {
//         "name": "British Virgin Islands",
//         "code": "VG",
//         "flag": "https://flagcdn.com/vg.svg"
//     },
//     {
//         "name": "Brunei",
//         "code": "BN",
//         "flag": "https://flagcdn.com/bn.svg"
//     },
//     {
//         "name": "Bulgaria",
//         "code": "BG",
//         "flag": "https://flagcdn.com/bg.svg"
//     },
//     {
//         "name": "Burkina Faso",
//         "code": "BF",
//         "flag": "https://flagcdn.com/bf.svg"
//     },
//     {
//         "name": "Burundi",
//         "code": "BI",
//         "flag": "https://flagcdn.com/bi.svg"
//     },
//     {
//         "name": "Cambodia",
//         "code": "KH",
//         "flag": "https://flagcdn.com/kh.svg"
//     },
//     {
//         "name": "Cameroon",
//         "code": "CM",
//         "flag": "https://flagcdn.com/cm.svg"
//     },
//     {
//         "name": "Canada",
//         "code": "CA",
//         "flag": "https://flagcdn.com/ca.svg"
//     },
//     {
//         "name": "Cape Verde",
//         "code": "CV",
//         "flag": "https://flagcdn.com/cv.svg"
//     },
//     {
//         "name": "Caribbean Netherlands",
//         "code": "BQ",
//         "flag": "https://flagcdn.com/bq.svg"
//     },
//     {
//         "name": "Cayman Islands",
//         "code": "KY",
//         "flag": "https://flagcdn.com/ky.svg"
//     },
//     {
//         "name": "Central African Republic",
//         "code": "CF",
//         "flag": "https://flagcdn.com/cf.svg"
//     },
//     {
//         "name": "Chad",
//         "code": "TD",
//         "flag": "https://flagcdn.com/td.svg"
//     },
//     {
//         "name": "Chile",
//         "code": "CL",
//         "flag": "https://flagcdn.com/cl.svg"
//     },
//     {
//         "name": "China",
//         "code": "CN",
//         "flag": "https://flagcdn.com/cn.svg"
//     },
//     {
//         "name": "Christmas Island",
//         "code": "CX",
//         "flag": "https://flagcdn.com/cx.svg"
//     },
//     {
//         "name": "Cocos (Keeling) Islands",
//         "code": "CC",
//         "flag": "https://flagcdn.com/cc.svg"
//     },
//     {
//         "name": "Colombia",
//         "code": "CO",
//         "flag": "https://flagcdn.com/co.svg"
//     },
//     {
//         "name": "Comoros",
//         "code": "KM",
//         "flag": "https://flagcdn.com/km.svg"
//     },
//     {
//         "name": "Cook Islands",
//         "code": "CK",
//         "flag": "https://flagcdn.com/ck.svg"
//     },
//     {
//         "name": "Costa Rica",
//         "code": "CR",
//         "flag": "https://flagcdn.com/cr.svg"
//     },
//     {
//         "name": "Croatia",
//         "code": "HR",
//         "flag": "https://flagcdn.com/hr.svg"
//     },
//     {
//         "name": "Cuba",
//         "code": "CU",
//         "flag": "https://flagcdn.com/cu.svg"
//     },
//     {
//         "name": "Curaçao",
//         "code": "CW",
//         "flag": "https://flagcdn.com/cw.svg"
//     },
//     {
//         "name": "Cyprus",
//         "code": "CY",
//         "flag": "https://flagcdn.com/cy.svg"
//     },
//     {
//         "name": "Czechia",
//         "code": "CZ",
//         "flag": "https://flagcdn.com/cz.svg"
//     },
//     {
//         "name": "Denmark",
//         "code": "DK",
//         "flag": "https://flagcdn.com/dk.svg"
//     },
//     {
//         "name": "Djibouti",
//         "code": "DJ",
//         "flag": "https://flagcdn.com/dj.svg"
//     },
//     {
//         "name": "Dominica",
//         "code": "DM",
//         "flag": "https://flagcdn.com/dm.svg"
//     },
//     {
//         "name": "Dominican Republic",
//         "code": "DO",
//         "flag": "https://flagcdn.com/do.svg"
//     },
//     {
//         "name": "DR Congo",
//         "code": "CD",
//         "flag": "https://flagcdn.com/cd.svg"
//     },
//     {
//         "name": "Ecuador",
//         "code": "EC",
//         "flag": "https://flagcdn.com/ec.svg"
//     },
//     {
//         "name": "Egypt",
//         "code": "EG",
//         "flag": "https://flagcdn.com/eg.svg"
//     },
//     {
//         "name": "El Salvador",
//         "code": "SV",
//         "flag": "https://flagcdn.com/sv.svg"
//     },
//     {
//         "name": "Equatorial Guinea",
//         "code": "GQ",
//         "flag": "https://flagcdn.com/gq.svg"
//     },
//     {
//         "name": "Eritrea",
//         "code": "ER",
//         "flag": "https://flagcdn.com/er.svg"
//     },
//     {
//         "name": "Estonia",
//         "code": "EE",
//         "flag": "https://flagcdn.com/ee.svg"
//     },
//     {
//         "name": "Eswatini",
//         "code": "SZ",
//         "flag": "https://flagcdn.com/sz.svg"
//     },
//     {
//         "name": "Ethiopia",
//         "code": "ET",
//         "flag": "https://flagcdn.com/et.svg"
//     },
//     {
//         "name": "Falkland Islands",
//         "code": "FK",
//         "flag": "https://flagcdn.com/fk.svg"
//     },
//     {
//         "name": "Faroe Islands",
//         "code": "FO",
//         "flag": "https://flagcdn.com/fo.svg"
//     },
//     {
//         "name": "Fiji",
//         "code": "FJ",
//         "flag": "https://flagcdn.com/fj.svg"
//     },
//     {
//         "name": "Finland",
//         "code": "FI",
//         "flag": "https://flagcdn.com/fi.svg"
//     },
//     {
//         "name": "France",
//         "code": "FR",
//         "flag": "https://flagcdn.com/fr.svg"
//     },
//     {
//         "name": "French Guiana",
//         "code": "GF",
//         "flag": "https://flagcdn.com/gf.svg"
//     },
//     {
//         "name": "French Polynesia",
//         "code": "PF",
//         "flag": "https://flagcdn.com/pf.svg"
//     },
//     {
//         "name": "French Southern and Antarctic Lands",
//         "code": "TF",
//         "flag": "https://flagcdn.com/tf.svg"
//     },
//     {
//         "name": "Gabon",
//         "code": "GA",
//         "flag": "https://flagcdn.com/ga.svg"
//     },
//     {
//         "name": "Gambia",
//         "code": "GM",
//         "flag": "https://flagcdn.com/gm.svg"
//     },
//     {
//         "name": "Georgia",
//         "code": "GE",
//         "flag": "https://flagcdn.com/ge.svg"
//     },
//     {
//         "name": "Germany",
//         "code": "DE",
//         "flag": "https://flagcdn.com/de.svg"
//     },
//     {
//         "name": "Ghana",
//         "code": "GH",
//         "flag": "https://flagcdn.com/gh.svg"
//     },
//     {
//         "name": "Gibraltar",
//         "code": "GI",
//         "flag": "https://flagcdn.com/gi.svg"
//     },
//     {
//         "name": "Greece",
//         "code": "GR",
//         "flag": "https://flagcdn.com/gr.svg"
//     },
//     {
//         "name": "Greenland",
//         "code": "GL",
//         "flag": "https://flagcdn.com/gl.svg"
//     },
//     {
//         "name": "Grenada",
//         "code": "GD",
//         "flag": "https://flagcdn.com/gd.svg"
//     },
//     {
//         "name": "Guadeloupe",
//         "code": "GP",
//         "flag": "https://flagcdn.com/gp.svg"
//     },
//     {
//         "name": "Guam",
//         "code": "GU",
//         "flag": "https://flagcdn.com/gu.svg"
//     },
//     {
//         "name": "Guatemala",
//         "code": "GT",
//         "flag": "https://flagcdn.com/gt.svg"
//     },
//     {
//         "name": "Guernsey",
//         "code": "GG",
//         "flag": "https://flagcdn.com/gg.svg"
//     },
//     {
//         "name": "Guinea",
//         "code": "GN",
//         "flag": "https://flagcdn.com/gn.svg"
//     },
//     {
//         "name": "Guinea-Bissau",
//         "code": "GW",
//         "flag": "https://flagcdn.com/gw.svg"
//     },
//     {
//         "name": "Guyana",
//         "code": "GY",
//         "flag": "https://flagcdn.com/gy.svg"
//     },
//     {
//         "name": "Haiti",
//         "code": "HT",
//         "flag": "https://flagcdn.com/ht.svg"
//     },
//     {
//         "name": "Heard Island and McDonald Islands",
//         "code": "HM",
//         "flag": "https://flagcdn.com/hm.svg"
//     },
//     {
//         "name": "Honduras",
//         "code": "HN",
//         "flag": "https://flagcdn.com/hn.svg"
//     },
//     {
//         "name": "Hong Kong",
//         "code": "HK",
//         "flag": "https://flagcdn.com/hk.svg"
//     },
//     {
//         "name": "Hungary",
//         "code": "HU",
//         "flag": "https://flagcdn.com/hu.svg"
//     },
//     {
//         "name": "Iceland",
//         "code": "IS",
//         "flag": "https://flagcdn.com/is.svg"
//     },
//     {
//         "name": "India",
//         "code": "IN",
//         "flag": "https://flagcdn.com/in.svg"
//     },
//     {
//         "name": "Indonesia",
//         "code": "ID",
//         "flag": "https://flagcdn.com/id.svg"
//     },
//     {
//         "name": "Iran",
//         "code": "IR",
//         "flag": "https://flagcdn.com/ir.svg"
//     },
//     {
//         "name": "Iraq",
//         "code": "IQ",
//         "flag": "https://flagcdn.com/iq.svg"
//     },
//     {
//         "name": "Ireland",
//         "code": "IE",
//         "flag": "https://flagcdn.com/ie.svg"
//     },
//     {
//         "name": "Isle of Man",
//         "code": "IM",
//         "flag": "https://flagcdn.com/im.svg"
//     },
//     {
//         "name": "Israel",
//         "code": "IL",
//         "flag": "https://flagcdn.com/il.svg"
//     },
//     {
//         "name": "Italy",
//         "code": "IT",
//         "flag": "https://flagcdn.com/it.svg"
//     },
//     {
//         "name": "Ivory Coast",
//         "code": "CI",
//         "flag": "https://flagcdn.com/ci.svg"
//     },
//     {
//         "name": "Jamaica",
//         "code": "JM",
//         "flag": "https://flagcdn.com/jm.svg"
//     },
//     {
//         "name": "Japan",
//         "code": "JP",
//         "flag": "https://flagcdn.com/jp.svg"
//     },
//     {
//         "name": "Jersey",
//         "code": "JE",
//         "flag": "https://flagcdn.com/je.svg"
//     },
//     {
//         "name": "Jordan",
//         "code": "JO",
//         "flag": "https://flagcdn.com/jo.svg"
//     },
//     {
//         "name": "Kazakhstan",
//         "code": "KZ",
//         "flag": "https://flagcdn.com/kz.svg"
//     },
//     {
//         "name": "Kenya",
//         "code": "KE",
//         "flag": "https://flagcdn.com/ke.svg"
//     },
//     {
//         "name": "Kiribati",
//         "code": "KI",
//         "flag": "https://flagcdn.com/ki.svg"
//     },
//     {
//         "name": "Kosovo",
//         "code": "XK",
//         "flag": "https://flagcdn.com/xk.svg"
//     },
//     {
//         "name": "Kuwait",
//         "code": "KW",
//         "flag": "https://flagcdn.com/kw.svg"
//     },
//     {
//         "name": "Kyrgyzstan",
//         "code": "KG",
//         "flag": "https://flagcdn.com/kg.svg"
//     },
//     {
//         "name": "Laos",
//         "code": "LA",
//         "flag": "https://flagcdn.com/la.svg"
//     },
//     {
//         "name": "Latvia",
//         "code": "LV",
//         "flag": "https://flagcdn.com/lv.svg"
//     },
//     {
//         "name": "Lebanon",
//         "code": "LB",
//         "flag": "https://flagcdn.com/lb.svg"
//     },
//     {
//         "name": "Lesotho",
//         "code": "LS",
//         "flag": "https://flagcdn.com/ls.svg"
//     },
//     {
//         "name": "Liberia",
//         "code": "LR",
//         "flag": "https://flagcdn.com/lr.svg"
//     },
//     {
//         "name": "Libya",
//         "code": "LY",
//         "flag": "https://flagcdn.com/ly.svg"
//     },
//     {
//         "name": "Liechtenstein",
//         "code": "LI",
//         "flag": "https://flagcdn.com/li.svg"
//     },
//     {
//         "name": "Lithuania",
//         "code": "LT",
//         "flag": "https://flagcdn.com/lt.svg"
//     },
//     {
//         "name": "Luxembourg",
//         "code": "LU",
//         "flag": "https://flagcdn.com/lu.svg"
//     },
//     {
//         "name": "Macau",
//         "code": "MO",
//         "flag": "https://flagcdn.com/mo.svg"
//     },
//     {
//         "name": "Madagascar",
//         "code": "MG",
//         "flag": "https://flagcdn.com/mg.svg"
//     },
//     {
//         "name": "Malawi",
//         "code": "MW",
//         "flag": "https://flagcdn.com/mw.svg"
//     },
//     {
//         "name": "Malaysia",
//         "code": "MY",
//         "flag": "https://flagcdn.com/my.svg"
//     },
//     {
//         "name": "Maldives",
//         "code": "MV",
//         "flag": "https://flagcdn.com/mv.svg"
//     },
//     {
//         "name": "Mali",
//         "code": "ML",
//         "flag": "https://flagcdn.com/ml.svg"
//     },
//     {
//         "name": "Malta",
//         "code": "MT",
//         "flag": "https://flagcdn.com/mt.svg"
//     },
//     {
//         "name": "Marshall Islands",
//         "code": "MH",
//         "flag": "https://flagcdn.com/mh.svg"
//     },
//     {
//         "name": "Martinique",
//         "code": "MQ",
//         "flag": "https://flagcdn.com/mq.svg"
//     },
//     {
//         "name": "Mauritania",
//         "code": "MR",
//         "flag": "https://flagcdn.com/mr.svg"
//     },
//     {
//         "name": "Mauritius",
//         "code": "MU",
//         "flag": "https://flagcdn.com/mu.svg"
//     },
//     {
//         "name": "Mayotte",
//         "code": "YT",
//         "flag": "https://flagcdn.com/yt.svg"
//     },
//     {
//         "name": "Mexico",
//         "code": "MX",
//         "flag": "https://flagcdn.com/mx.svg"
//     },
//     {
//         "name": "Micronesia",
//         "code": "FM",
//         "flag": "https://flagcdn.com/fm.svg"
//     },
//     {
//         "name": "Moldova",
//         "code": "MD",
//         "flag": "https://flagcdn.com/md.svg"
//     },
//     {
//         "name": "Monaco",
//         "code": "MC",
//         "flag": "https://flagcdn.com/mc.svg"
//     },
//     {
//         "name": "Mongolia",
//         "code": "MN",
//         "flag": "https://flagcdn.com/mn.svg"
//     },
//     {
//         "name": "Montenegro",
//         "code": "ME",
//         "flag": "https://flagcdn.com/me.svg"
//     },
//     {
//         "name": "Montserrat",
//         "code": "MS",
//         "flag": "https://flagcdn.com/ms.svg"
//     },
//     {
//         "name": "Morocco",
//         "code": "MA",
//         "flag": "https://flagcdn.com/ma.svg"
//     },
//     {
//         "name": "Mozambique",
//         "code": "MZ",
//         "flag": "https://flagcdn.com/mz.svg"
//     },
//     {
//         "name": "Myanmar",
//         "code": "MM",
//         "flag": "https://flagcdn.com/mm.svg"
//     },
//     {
//         "name": "Namibia",
//         "code": "NA",
//         "flag": "https://flagcdn.com/na.svg"
//     },
//     {
//         "name": "Nauru",
//         "code": "NR",
//         "flag": "https://flagcdn.com/nr.svg"
//     },
//     {
//         "name": "Nepal",
//         "code": "NP",
//         "flag": "https://flagcdn.com/np.svg"
//     },
//     {
//         "name": "Netherlands",
//         "code": "NL",
//         "flag": "https://flagcdn.com/nl.svg"
//     },
//     {
//         "name": "New Caledonia",
//         "code": "NC",
//         "flag": "https://flagcdn.com/nc.svg"
//     },
//     {
//         "name": "New Zealand",
//         "code": "NZ",
//         "flag": "https://flagcdn.com/nz.svg"
//     },
//     {
//         "name": "Nicaragua",
//         "code": "NI",
//         "flag": "https://flagcdn.com/ni.svg"
//     },
//     {
//         "name": "Niger",
//         "code": "NE",
//         "flag": "https://flagcdn.com/ne.svg"
//     },
//     {
//         "name": "Nigeria",
//         "code": "NG",
//         "flag": "https://flagcdn.com/ng.svg"
//     },
//     {
//         "name": "Niue",
//         "code": "NU",
//         "flag": "https://flagcdn.com/nu.svg"
//     },
//     {
//         "name": "Norfolk Island",
//         "code": "NF",
//         "flag": "https://flagcdn.com/nf.svg"
//     },
//     {
//         "name": "North Korea",
//         "code": "KP",
//         "flag": "https://flagcdn.com/kp.svg"
//     },
//     {
//         "name": "North Macedonia",
//         "code": "MK",
//         "flag": "https://flagcdn.com/mk.svg"
//     },
//     {
//         "name": "Northern Mariana Islands",
//         "code": "MP",
//         "flag": "https://flagcdn.com/mp.svg"
//     },
//     {
//         "name": "Norway",
//         "code": "NO",
//         "flag": "https://flagcdn.com/no.svg"
//     },
//     {
//         "name": "Oman",
//         "code": "OM",
//         "flag": "https://flagcdn.com/om.svg"
//     },
//     {
//         "name": "Pakistan",
//         "code": "PK",
//         "flag": "https://flagcdn.com/pk.svg"
//     },
//     {
//         "name": "Palau",
//         "code": "PW",
//         "flag": "https://flagcdn.com/pw.svg"
//     },
//     {
//         "name": "Palestine",
//         "code": "PS",
//         "flag": "https://flagcdn.com/ps.svg"
//     },
//     {
//         "name": "Panama",
//         "code": "PA",
//         "flag": "https://flagcdn.com/pa.svg"
//     },
//     {
//         "name": "Papua New Guinea",
//         "code": "PG",
//         "flag": "https://flagcdn.com/pg.svg"
//     },
//     {
//         "name": "Paraguay",
//         "code": "PY",
//         "flag": "https://flagcdn.com/py.svg"
//     },
//     {
//         "name": "Peru",
//         "code": "PE",
//         "flag": "https://flagcdn.com/pe.svg"
//     },
//     {
//         "name": "Philippines",
//         "code": "PH",
//         "flag": "https://flagcdn.com/ph.svg"
//     },
//     {
//         "name": "Pitcairn Islands",
//         "code": "PN",
//         "flag": "https://flagcdn.com/pn.svg"
//     },
//     {
//         "name": "Poland",
//         "code": "PL",
//         "flag": "https://flagcdn.com/pl.svg"
//     },
//     {
//         "name": "Portugal",
//         "code": "PT",
//         "flag": "https://flagcdn.com/pt.svg"
//     },
//     {
//         "name": "Puerto Rico",
//         "code": "PR",
//         "flag": "https://flagcdn.com/pr.svg"
//     },
//     {
//         "name": "Qatar",
//         "code": "QA",
//         "flag": "https://flagcdn.com/qa.svg"
//     },
//     {
//         "name": "Republic of the Congo",
//         "code": "CG",
//         "flag": "https://flagcdn.com/cg.svg"
//     },
//     {
//         "name": "Réunion",
//         "code": "RE",
//         "flag": "https://flagcdn.com/re.svg"
//     },
//     {
//         "name": "Romania",
//         "code": "RO",
//         "flag": "https://flagcdn.com/ro.svg"
//     },
//     {
//         "name": "Russia",
//         "code": "RU",
//         "flag": "https://flagcdn.com/ru.svg"
//     },
//     {
//         "name": "Rwanda",
//         "code": "RW",
//         "flag": "https://flagcdn.com/rw.svg"
//     },
//     {
//         "name": "Saint Barthélemy",
//         "code": "BL",
//         "flag": "https://flagcdn.com/bl.svg"
//     },
//     {
//         "name": "Saint Helena",
//         "code": "SH",
//         "flag": "https://flagcdn.com/sh.svg"
//     },
//     {
//         "name": "Saint Kitts and Nevis",
//         "code": "KN",
//         "flag": "https://flagcdn.com/kn.svg"
//     },
//     {
//         "name": "Saint Lucia",
//         "code": "LC",
//         "flag": "https://flagcdn.com/lc.svg"
//     },
//     {
//         "name": "Saint Martin",
//         "code": "MF",
//         "flag": "https://flagcdn.com/mf.svg"
//     },
//     {
//         "name": "Saint Pierre and Miquelon",
//         "code": "PM",
//         "flag": "https://flagcdn.com/pm.svg"
//     },
//     {
//         "name": "Saint Vincent and the Grenadines",
//         "code": "VC",
//         "flag": "https://flagcdn.com/vc.svg"
//     },
//     {
//         "name": "Samoa",
//         "code": "WS",
//         "flag": "https://flagcdn.com/ws.svg"
//     },
//     {
//         "name": "San Marino",
//         "code": "SM",
//         "flag": "https://flagcdn.com/sm.svg"
//     },
//     {
//         "name": "São Tomé and Príncipe",
//         "code": "ST",
//         "flag": "https://flagcdn.com/st.svg"
//     },
//     {
//         "name": "Saudi Arabia",
//         "code": "SA",
//         "flag": "https://flagcdn.com/sa.svg"
//     },
//     {
//         "name": "Senegal",
//         "code": "SN",
//         "flag": "https://flagcdn.com/sn.svg"
//     },
//     {
//         "name": "Serbia",
//         "code": "RS",
//         "flag": "https://flagcdn.com/rs.svg"
//     },
//     {
//         "name": "Seychelles",
//         "code": "SC",
//         "flag": "https://flagcdn.com/sc.svg"
//     },
//     {
//         "name": "Sierra Leone",
//         "code": "SL",
//         "flag": "https://flagcdn.com/sl.svg"
//     },
//     {
//         "name": "Singapore",
//         "code": "SG",
//         "flag": "https://flagcdn.com/sg.svg"
//     },
//     {
//         "name": "Sint Maarten",
//         "code": "SX",
//         "flag": "https://flagcdn.com/sx.svg"
//     },
//     {
//         "name": "Slovakia",
//         "code": "SK",
//         "flag": "https://flagcdn.com/sk.svg"
//     },
//     {
//         "name": "Slovenia",
//         "code": "SI",
//         "flag": "https://flagcdn.com/si.svg"
//     },
//     {
//         "name": "Solomon Islands",
//         "code": "SB",
//         "flag": "https://flagcdn.com/sb.svg"
//     },
//     {
//         "name": "Somalia",
//         "code": "SO",
//         "flag": "https://flagcdn.com/so.svg"
//     },
//     {
//         "name": "South Africa",
//         "code": "ZA",
//         "flag": "https://flagcdn.com/za.svg"
//     },
//     {
//         "name": "South Georgia",
//         "code": "GS",
//         "flag": "https://flagcdn.com/gs.svg"
//     },
//     {
//         "name": "South Korea",
//         "code": "KR",
//         "flag": "https://flagcdn.com/kr.svg"
//     },
//     {
//         "name": "South Sudan",
//         "code": "SS",
//         "flag": "https://flagcdn.com/ss.svg"
//     },
//     {
//         "name": "Spain",
//         "code": "ES",
//         "flag": "https://flagcdn.com/es.svg"
//     },
//     {
//         "name": "Sri Lanka",
//         "code": "LK",
//         "flag": "https://flagcdn.com/lk.svg"
//     },
//     {
//         "name": "Sudan",
//         "code": "SD",
//         "flag": "https://flagcdn.com/sd.svg"
//     },
//     {
//         "name": "Suriname",
//         "code": "SR",
//         "flag": "https://flagcdn.com/sr.svg"
//     },
//     {
//         "name": "Svalbard and Jan Mayen",
//         "code": "SJ",
//         "flag": "https://flagcdn.com/sj.svg"
//     },
//     {
//         "name": "Sweden",
//         "code": "SE",
//         "flag": "https://flagcdn.com/se.svg"
//     },
//     {
//         "name": "Switzerland",
//         "code": "CH",
//         "flag": "https://flagcdn.com/ch.svg"
//     },
//     {
//         "name": "Syria",
//         "code": "SY",
//         "flag": "https://flagcdn.com/sy.svg"
//     },
//     {
//         "name": "Taiwan",
//         "code": "TW",
//         "flag": "https://flagcdn.com/tw.svg"
//     },
//     {
//         "name": "Tajikistan",
//         "code": "TJ",
//         "flag": "https://flagcdn.com/tj.svg"
//     },
//     {
//         "name": "Tanzania",
//         "code": "TZ",
//         "flag": "https://flagcdn.com/tz.svg"
//     },
//     {
//         "name": "Thailand",
//         "code": "TH",
//         "flag": "https://flagcdn.com/th.svg"
//     },
//     {
//         "name": "Timor-Leste",
//         "code": "TL",
//         "flag": "https://flagcdn.com/tl.svg"
//     },
//     {
//         "name": "Togo",
//         "code": "TG",
//         "flag": "https://flagcdn.com/tg.svg"
//     },
//     {
//         "name": "Tokelau",
//         "code": "TK",
//         "flag": "https://flagcdn.com/tk.svg"
//     },
//     {
//         "name": "Tonga",
//         "code": "TO",
//         "flag": "https://flagcdn.com/to.svg"
//     },
//     {
//         "name": "Trinidad and Tobago",
//         "code": "TT",
//         "flag": "https://flagcdn.com/tt.svg"
//     },
//     {
//         "name": "Tunisia",
//         "code": "TN",
//         "flag": "https://flagcdn.com/tn.svg"
//     },
//     {
//         "name": "Turkey",
//         "code": "TR",
//         "flag": "https://flagcdn.com/tr.svg"
//     },
//     {
//         "name": "Turkmenistan",
//         "code": "TM",
//         "flag": "https://flagcdn.com/tm.svg"
//     },
//     {
//         "name": "Turks and Caicos Islands",
//         "code": "TC",
//         "flag": "https://flagcdn.com/tc.svg"
//     },
//     {
//         "name": "Tuvalu",
//         "code": "TV",
//         "flag": "https://flagcdn.com/tv.svg"
//     },
//     {
//         "name": "Uganda",
//         "code": "UG",
//         "flag": "https://flagcdn.com/ug.svg"
//     },
//     {
//         "name": "Ukraine",
//         "code": "UA",
//         "flag": "https://flagcdn.com/ua.svg"
//     },
//     {
//         "name": "United Arab Emirates",
//         "code": "AE",
//         "flag": "https://flagcdn.com/ae.svg"
//     },
//     {
//         "name": "United Kingdom",
//         "code": "GB",
//         "flag": "https://flagcdn.com/gb.svg"
//     },
//     {
//         "name": "United States",
//         "code": "US",
//         "flag": "https://flagcdn.com/us.svg"
//     },
//     {
//         "name": "United States Minor Outlying Islands",
//         "code": "UM",
//         "flag": "https://flagcdn.com/um.svg"
//     },
//     {
//         "name": "United States Virgin Islands",
//         "code": "VI",
//         "flag": "https://flagcdn.com/vi.svg"
//     },
//     {
//         "name": "Uruguay",
//         "code": "UY",
//         "flag": "https://flagcdn.com/uy.svg"
//     },
//     {
//         "name": "Uzbekistan",
//         "code": "UZ",
//         "flag": "https://flagcdn.com/uz.svg"
//     },
//     {
//         "name": "Vanuatu",
//         "code": "VU",
//         "flag": "https://flagcdn.com/vu.svg"
//     },
//     {
//         "name": "Vatican City",
//         "code": "VA",
//         "flag": "https://flagcdn.com/va.svg"
//     },
//     {
//         "name": "Venezuela",
//         "code": "VE",
//         "flag": "https://flagcdn.com/ve.svg"
//     },
//     {
//         "name": "Vietnam",
//         "code": "VN",
//         "flag": "https://flagcdn.com/vn.svg"
//     },
//     {
//         "name": "Wallis and Futuna",
//         "code": "WF",
//         "flag": "https://flagcdn.com/wf.svg"
//     },
//     {
//         "name": "Western Sahara",
//         "code": "EH",
//         "flag": "https://flagcdn.com/eh.svg"
//     },
//     {
//         "name": "Yemen",
//         "code": "YE",
//         "flag": "https://flagcdn.com/ye.svg"
//     },
//     {
//         "name": "Zambia",
//         "code": "ZM",
//         "flag": "https://flagcdn.com/zm.svg"
//     },
//     {
//         "name": "Zimbabwe",
//         "code": "ZW",
//         "flag": "https://flagcdn.com/zw.svg"
//     }
// ]

export const aboutUsResult = [
    {
        "WhatWeOffer": `[{"key":"history","title":"Our History","description1":"Founded with a vision to transform the way businesses operate, NextAspect Technologies began as a small, ambitious startup with a focus on innovative software development. Our journey started by offering specialized services in SharePoint and Office 365 tools, quickly expanding our expertise to include PowerApps, Teams, and Office Add-ins.","description2":"Today, NextAspect Technologies continues to innovate and lead in the development and consulting space, providing cutting-edge solutions that enable organizations to thrive in the modern digital landscape.","image":"history.png"},{"key":"vision","title":"Our Vision","description1":"At NextAspect Technologies, we envision a future where organizations thrive in a dynamic and interconnected digital landscape. Our goal is to be a global leader in software development and consulting, specializing in Microsoft technologies like SharePoint, PowerApps, Teams, and Office Add-ins","description2":"We aim to empower businesses by providing innovative solutions that transform the way they operate. By leveraging advanced technology and our expertise, we aspire to simplify complex processes, foster collaboration, and enhance productivity for teams worldwide.","image":"vision.png"},{"key":"mission","title":"Our Mission","description1":"Our mission is to empower businesses with cutting-edge technology solutions that drive growth and success.","description2":"We are committed to delivering outstanding results through our expertise, dedication, and innovation.","image":"mission.png"},{"key":"strategy","title":"Our Strategy","description1":"Our strategy is to combine deep industry knowledge with advanced technical skills to create custom solutions tailored to our clients' needs.","description2":"We focus on building long-term partnerships based on trust, transparency, and mutual success.","image":"strategy.png"}]`,
        "Feature": `[{"title":"Customized Solutions","description":"We analyze each organization's unique needs to provide expert guidance and develop tailored solutions that ensure optimal results.","icon":"customized-solutions"},{"title":"Expertise","description":"Our team of experienced developers has a deep understanding of SharePoint, PowerApps,Teams, and Office Add-ins, enabling us to deliver high-quality solutions that meet the highest standards of performance and reliability.","icon":"expertise"},{"title":"Collaboration and Communication","description":"We believe in open and transparent communication throughout the project lifecycle. We work closely with our clients, keeping them involved at every stage, and providing regular updates to ensure their vision is realized.","icon":"collaboration"},{"title":"Timely Delivery","description":"We value your time and strive to deliver projects within agreed-upon timelines, without compromising on quality. Our efficient project management approach ensures that your project is completed on schedule, meeting your business objectives.","icon":"timely-delivery"}]`,
        "WhyChooseUs": `{"title":"We believe in people and technology.","subTitle":"Leading IT Company with Innovative Products and Services","description":"NextAspect Technologies stands at the cutting edge of innovation. Our vibrant team of professionals and industry experts is dedicated to developing revolutionary software products and IT services. We’re committed to redefining the tech landscape with solutions that drive progress and deliver exceptional value.","image":"https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/About%20Us%2Fabout-us.jpg?alt=media&token=f3190f3e-4eaa-4614-b6ee-efa85e0d403a","appLogo":"https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/App%20Logo%2FFinalLogo.png?alt=media&token=7b6d1f40-8fdd-40b1-b12f-d220fc47cab0"}`,
        "Id": "MS2xVh0rl8o0fEVUbBar"
    }
];

export const termsAndConditionsData = [
    {
        Title: 'Agreement to Terms',
        Content: 'Please read these Terms and Conditions carefully before using the NextAspect Technologies website. By accessing or using our site, you agree to comply with and be bound by these terms.',
    },
    {
        Title: 'Acceptance of Conditions',
        Content: 'The user must agree and accept all the "Terms and Conditions" before using any services or content provided by NextAspect Technologies.',
    },
    {
        Title: 'Modification of Terms',
        Content: 'NextAspect Technologies reserves the right to modify, update, or amend these Terms and Conditions at any time without prior notice. It is your responsibility to periodically review this page for updates.',
    },
    {
        Title: 'Ownership of Content',
        Content: 'The website www.nextaspecttech.com and all content, including but not limited to text, images, graphics, logos, software, and multimedia, is the property of NextAspect Technologies unless otherwise stated. Unauthorized use, reproduction, or redistribution of the content is strictly prohibited.',
    },
    {
        Title: 'Intellectual Property Rights',
        Content: 'All trademarks, service marks, and trade names associated with NextAspect Technologies are the property of the company. You are prohibited from using any trademark, service mark, logo, or content without express written permission.',
    },
    {
        Title: 'Prohibited Actions',
        Content: 'Users are not permitted to use any contact information, such as email addresses or phone numbers provided on this website, for sending unsolicited promotional materials or spam.',
    },
    {
        Title: 'Third-Party Links',
        Content: 'Links to third-party websites may be provided on the NextAspect Technologies website for convenience. These third-party websites are not controlled by NextAspect, and we are not responsible for their content or policies. Accessing third-party sites is at your own risk.',
    },
    {
        Title: 'Limitation of Liability',
        Content: 'NextAspect Technologies is not liable for any damages or data loss resulting from your use of this website, including but not limited to the downloading of any material from the site.',
    },
    {
        Title: 'Privacy Policy',
        Content: 'The website may collect personal data from users, which is governed by our Privacy Policy. By using the site, you agree to the collection and use of your information as described in the <a href="/privacy-policy">Privacy Policy.</a>',
    },
    {
        Title: 'Contact Us',
        Contents: 'If you have any questions or concerns about these Terms and Conditions, please <a href="/contact-us">contact us</a>',
    },
];

export const privacyPolicyResults = {
    title: "Privacy Policy",
    introduction: [
        `NextAspect Technologies ("we," "our," or "us") is committed to protecting the privacy and security of the personal information of our clients, website visitors, and business partners. This Privacy Policy outlines the types of personal information we collect, how we use and safeguard that information, and your rights to your data.`,
        `By interacting with NextAspect Technologies through our website or services, you agree to the practices described in this Privacy Policy.`
    ],
    sections: [
        {
            title: "Applicable To",
            content: [
                `This privacy statement applies to individuals ("users" or "you") who engage with our website, subscribe to our blogs, and request information.`
            ],
            listItems: []
        },
        {
            title: "Information We Collect",
            content: [
                "Data is collected from various sources based on your interactions with our services, such as when you subscribe to our blogs or request information through the Contact Us form."
            ],
            listItems: [
                {
                    subTitle: "Your Name",
                    items: []
                },
                {
                    subTitle: "Your Country",
                    items: []
                },
                {
                    subTitle: "Your Email Address",
                    items: []
                },
                {
                    subTitle: "Your Phone Number",
                    items: []
                },
                {
                    subTitle: "Any other information you choose to share",
                    items: []
                },
            ]
        },
        {
            title: "Reasons for Collecting Your Data with Your Consent",
            content: ["We collect your data for several key purposes:"],
            listItems: [
                "To engage with you regarding the services you’ve expressed interest in or for ongoing projects we are handling together.",
                "To inform you via email about any changes to this Privacy Policy, Terms of Service, or other significant updates.",
                "To keep you updated on new products and services we offer, as well as upcoming events, special offers, and promotions that align with your interests.",
                "To fulfill your requests for services, facilitate collaboration, gather requirements, and manage project development and deployment.",
                "To enhance customer support and assess our interactions with you for continuous improvement.",
                "To identify and prevent fraudulent transactions and unauthorized activities, report spam, and safeguard the rights and interests of NextAspect Technologies and its users.",
                "To refine and expand our records, discover new customers, and deliver products and services that may appeal to you.",
                "To oversee our website operations, monitor visitor navigation, and gain insights into user behavior for enhanced support.",
                "To analyze and improve our marketing strategies, tailoring suggestions to better meet your preferences."
            ]
        },
        {
            title: "Is Your Data Shared?",
            content: [
                "We value your privacy and do not share your data with third parties without your explicit consent."
            ],
            listItems: []
        },
        {
            title: "How We Protect Your Information",
            content: ["We are committed to keeping your information confidential and secure. Here’s how we ensure your data is protected:"],
            listItems: [
                {
                    subTitle: "Purposeful Data Collection",
                    items: [
                        "We only collect your information to facilitate effective communication and provide you with the services you need. Your data is handled responsibly to prevent any risk of leakage or exposure."
                    ]
                },
                {
                    subTitle: "Secure Forms",
                    items: [
                        "While browsing our website, you may come across forms requesting details like your name and contact number. Our privacy policy guarantees that any information you provide will not be misused, sold, or rented under any circumstances."
                    ]
                },
                {
                    subTitle: "No Third-Party Sharing",
                    items: [
                        "We do not share your data with any third parties. Your information is strictly confidential and will not be sold, rented, or misused in any way. However, it may be used for future communication and internal record-keeping purposes."
                    ]
                },
                {
                    subTitle: "Control and Oversight",
                    items: [
                        "We maintain strict control over how your information is handled, used, and stored, ensuring that your data is always protected."
                    ]
                }
            ]
        },
        {
            title: "Your Data Rights",
            content: [
                "You have complete control over the information we store and how it is used. Here are the choices available to you:"
            ],
            listItems: [
                {
                    subTitle: "Unsubscribe Anytime",
                    items: [
                        "You can easily unsubscribe from any emails we send and adjust your notification preferences to stop receiving communications from us."
                    ]
                },
                {
                    subTitle: "Opt-Out of Forms",
                    items: [
                        "You have the option to not share your information by simply not filling out any forms on our website."
                    ]
                },
                {
                    subTitle: "Change Your Consent",
                    items: [
                        "You can modify or withdraw your consent for any specific use of your data at any time."
                    ]
                },
                {
                    subTitle: "Contact Us",
                    items: [
                        "If you have any questions regarding our privacy policy or how we handle your data, we welcome your inquiries at <a href='mailto:nextaspecttech@gmail.com'>nextaspecttech@gmail.com</a>"
                    ]
                }
            ]
        },
        {
            title: "Cookies and Tracking Technologies",
            content: [
                "We use cookies and similar technologies to enhance your experience on our website. You may adjust your browser settings to refuse cookies; however, this may limit some functionalities of our website."
            ],
            listItems: []
        },
        {
            title: "Links to External Websites",
            content: [
                "Our service may contain links to websites that are not operated by us. Here's what you need to know:"
            ],
            listItems: [
                {
                    subTitle: "Third-Party Links",
                    items: ["Clicking on a third-party link will take you to an external website outside our control."]
                },
                {
                    subTitle: "Review Policies",
                    items: ["We strongly recommend that you review the privacy policy of any website you visit to understand how they handle your information."]
                },
                {
                    subTitle: "No Control",
                    items: ["We have no authority over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services."]
                }
            ]
        },
        {
            title: "Changes to this Privacy Policy",
            content: [
                "We reserve the right to modify this Privacy Policy at our discretion. Any changes will be posted on this page, and we encourage you to review it periodically to stay informed."
            ],
            listItems: []
        },
        {
            title: "Stay Safe from Scammers",
            content: [
                "This is the official website of NextAspect Technologies, and we do not operate under any other domains. We will never request payments unrelated to official client projects, such as recruitment fees.",
                "Be cautious of scammers pretending to represent us. NextAspect Technologies cannot be held responsible for any losses due to fraudulent activities, whether you fall victim knowingly or unknowingly.",
                "If you come across any suspicious behavior, please report it to us immediately using our official contact details. You can also report phishing attempts directly to Google."
            ],
            listItems: []
        },
        {
            title: "Get in Touch",
            content: [
                "If you have any questions or concerns about this Privacy Policy or our data practices, please <a href='/contact-us'>contact us</a>"
            ],
            listItems: []
        }
    ]
};

export const FAQsData = [
    {
        "Id": "prePurchase",
        "Label": "Pre-Purchase and Accounts Questions",
        "Questions": `[{"question":"What Are the Steps to Make a Purchase Online?","answer":"To purchase a product, simply visit the website and head to the <a href='/contact-us'>Contact Us</a> page. Fill out the contact form with your information, including the product you’re interested in. Once you submit the form, a representative will promptly reach out to guide you through the purchasing process and answer any questions you may have."},{"question":"Where Are My Receipt and License Keys?","answer":"You should receive your email receipt and login information shortly after your payment is approved, which typically happens almost immediately. If you don’t see an email within a few minutes, please check your junk folder. If it's not there, contact us so we can verify your payment and account status."},{"question":"How Do I Download My Purchased Items?","answer":"To download your purchase(s), please check your email for the download link sent after your payment was processed. If you can’t find the email, be sure to check your junk folder. If you need further assistance, please contact our support team."},{"question":"How Can I Access My Order Invoice?","answer":"To download your invoice, please check your email for the invoice link sent after your order confirmation. If you can’t locate the email, be sure to check your junk folder. For further assistance, feel free to contact our support team."},{"question":"Can I Try the Product Before Purchasing?","answer":"Yes, you can try the product before purchasing! We offer a trial version that allows you to test its features. Please visit our website for more details on how to access the trial. If you have any questions, feel free to reach out to our support team!"}]`
    },
    {
        "Id": "license",
        "Label": "License Questions - SharePoint web parts",
        "Questions": `[{"question":"Is the License a One-Time Purchase or Annual Renewal?","answer":"Licenses are valid for 1 year from the date of purchase, requiring annual renewal to maintain access to updates and support. Please check the product details for more information on renewal costs and benefits. If you have further questions, feel free to contact us for assistance!"},{"question":"Is My License Valid for Multiple Tenants?","answer":"Typically, licenses are issued for a single tenant. If you need to use the product across multiple tenants, please check the product’s licensing agreement or contact our support team for specific options and details."},{"question":"Is a Single License Valid for Multiple Pages and Sites?","answer":"Yes, you can utilize a single license for a web part across multiple pages and sites. This gives you the freedom to implement the web part wherever needed without purchasing additional licenses. If you have any more questions or need assistance, don't hesitate to reach out!"}]`
    },
    {
        "Id": "technical",
        "Label": "Technical Questions",
        "Questions": `[{"question":"What technologies does the product use?","answer":"Our product is built using the modern SharePoint Framework (SPFx), which is recommended by Microsoft. This framework incorporates advanced web technologies like JavaScript, TypeScript, and React, ensuring optimal performance and seamless compatibility with SharePoint environments. With SPFx, you can expect a robust and responsive solution tailored to enhance your SharePoint experience."},{"question":"How Do I Install the SharePoint App?","answer":"To install the SharePoint app, start by downloading the app package from the provided source. Navigate to your SharePoint site and go to 'Site Settings.' From there, select 'Add an app' under the 'Site Contents' section. Upload the app package and follow the prompts to complete the installation. Once installed, you can configure the app settings as needed. If you require further assistance, consult the documentation or contact our support team."},{"question":"How Do I Uninstall the SharePoint App?","answer":"To uninstall the SharePoint app, navigate to your site settings and find the 'Site Contents' section. Locate the app you wish to remove, click on the ellipsis (three dots) next to it, and select 'Remove.' Follow any additional prompts to complete the unInstallation. If you need further assistance, refer to the documentation or contact our support team for help."},{"question":"How Do I Update the SharePoint App?","answer":"To update the SharePoint app, first download the latest version of the app package from our site. Navigate to your SharePoint site and go to 'Site Contents.' Locate the existing app, click on the ellipsis (three dots) next to it, and select 'Remove' to uninstall the old version. Next, upload the new app package by selecting 'Add an app' and following the prompts. Once the update is complete, configure any necessary settings. If you need further assistance, refer to the documentation or contact our support team."},{"question":"What browsers are supported?","answer":"The product is designed to work seamlessly with the latest versions of major browsers, including Chrome, Firefox, Edge, and Safari."},{"question":"Is there a limit to the number of users?","answer":"A single license allows multiple users to access the product within the licensed site or page, offering great flexibility."},{"question":"Can I customize the product?","answer":"Yes, the product is designed for customization. You can modify it according to your specific requirements, using the provided documentation as a guide."},{"question":"Where can I find support if I encounter issues?","answer":"Support is available through our contact page. You can submit a ticket or reach out via email for assistance with any issues."},{"question":"Can I test the product before purchasing?","answer":"Many of our products offer a trial period. Please check the product page for details on trial availability and duration."}]`
    },
    {
        "Id": "security",
        "Label": "Security and Data concerns",
        "Questions": `[{"question":"How is my data protected?","answer":"NextAspect Technologies values the safety and protection of customer data above all else. Our web parts utilize the SharePoint Framework (SPFx) development model and full trust client-side solutions that ensure seamless integration of SharePoint data without compromising the security of SharePoint environments. Customers can rest assured that their data is not collected by NextAspect Technologies."},{"question":"What kind of data does the product collect?","answer":"Our web parts collect only the essential information needed to activate and verify your license. This includes your SharePoint tenant URL (e.g., mycompany.sharepoint.com). This information is used solely for licensing purposes and is not stored or shared by NextAspect Technologies."},{"question":"Are there any user access controls available?","answer":"Yes, the product supports user access controls, allowing you to define permissions and restrict access based on user roles within your organization."}]`
    },
    {
        "Id": "Customization",
        "Label": "Customization",
        "Questions": `[{"question":"How does it work?","answer":"Customization lets you adjust the app to fit your specific needs. You can easily modify features, layouts, and settings to better suit your business requirements. Please note that customizations come with a fee, which may vary based on the extent of the changes and may include additional fees depending on the scope of the modifications."},{"question":"What are the customization costs?","answer":"The pricing for customizations varies based on the specific features and level of changes requested. For example, if you want to adjust the layout of a dashboard or add new functionalities, the cost will differ based on the complexity of those changes. We will provide a detailed quote tailored to your needs. For an accurate estimate, please contact our support team with your customization requirements, and we’ll gladly assist you!"},{"question":"How do I order app customization?","answer":"To request app customization, simply reach out to our support team through the <a href='/contact-us'>Contact Us</a> page on our website. Provide details about the specific changes you’d like to make, such as adjusting layouts or adding features. We’ll review your request and provide you with a quote tailored to your needs. Once agreed upon, we’ll guide you through the process to get your customizations underway!"},{"question":"How do I install a customized app?","answer":"To install your customized app, first download the app package provided to you. Then, navigate to your SharePoint site and go to 'Site Contents.' Click on 'Add an app,' then upload the customized app package. Follow the on-screen prompts to complete the installation. If you need further assistance, please refer to the documentation or contact our support team for help!"}]`
    }
];

export const sitemapData = [
    {
        Title: "Home",
        Path: "/",
        SubLinks: ""
    },
    {
        Title: "About",
        Path: "/about-us",
        SubLinks: ""
    },
    {
        Title: "Products",
        Path: "/products",
        SubLinks: '[{"Title":"Smart HelpDesk","Path":"/smart-helpDesk"}]',
    },
    {
        Title: "Services",
        Path: "/services",
        SubLinks: '[{"Title":"Web Development","Path":"/web-development"},{"Title":"Custom Development","Path":"/custom-development"},{"Title":"Product Development","Path":"/product-development"},{"Title":"UX/UI Design","Path":"/ux-ui-design"},{"Title":"Software Testing & QA","Path":"/software-testing-qa"},{"Title":"IT Consultancy","Path":"/it-consultancy"}]',
    },
    {
        Title: "FAQs",
        Path: "/faqs",
        SubLinks: ""
    },
    {
        Title: "Resources",
        Path: "#",
        SubLinks: '[{"Title":"Terms And Conditions","Path":"/terms-conditions"},{"Title":"Privacy Policy","Path":"/privacy-policy"}]',
    },
    {
        Title: "Contact Us",
        Path: "/contact-us",
        SubLinks: ""
    },
];

export const Features = [
    {
        Title: 'Ticketing System',
        Description: 'A Ticketing System manages and resolves customer support requests efficiently, tracking issues from submission to resolution.',
        ImgSrc: 'ticket.png',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Ticket Assign',
        Description: 'Ticket Assign is a feature that allocates support requests to the right team members, ensuring timely and organized issue resolution.',
        ImgSrc: 'assign-ticket.png',
        IsNew: false,
        OrderNo: 2,
        IsActive: true
    },
    {
        Title: 'Reports',
        Description: 'Reports provide insights into support activities, tracking metrics like response time, resolution rates, and team performance for data-driven decision-making.',
        ImgSrc: 'report.png',
        IsNew: false,
        OrderNo: 3,
        IsActive: true
    },
    {
        Title: 'Automation',
        Description: 'Automation streamlines repetitive tasks, enhancing efficiency by auto-assigning tickets, sending alerts, and updating statuses without manual intervention.',
        ImgSrc: 'automation.png',
        IsNew: false,
        OrderNo: 4,
        IsActive: true
    },
    {
        Title: 'Email To Ticket',
        Description: 'Email to Ticket converts incoming emails into support tickets automatically, ensuring customer requests are captured and tracked in the system seamlessly.',
        ImgSrc: 'email-ticket.png',
        IsNew: false,
        OrderNo: 5,
        IsActive: true
    },
    {
        Title: 'Automated Replies',
        Description: 'Automated Replies offers pre-written replies for common inquiries, allowing support teams to respond quickly and consistently to customer questions.',
        ImgSrc: 'canned-message.png',
        IsNew: false,
        OrderNo: 6,
        IsActive: true
    },
    {
        Title: 'Theme settings',
        Description: 'Theme Settings allow customization of the interface, enabling users to adjust colors and layout preferences for a personalized look and feel.',
        ImgSrc: 'theme.png',
        IsNew: false,
        OrderNo: 7,
        IsActive: true
    },
    {
        Title: 'Live Notifications',
        Description: 'Live Notifications provide real-time updates on ticket status, assignments, and responses, keeping users informed instantly as changes happen.',
        ImgSrc: 'notification.png',
        IsNew: false,
        OrderNo: 8,
        IsActive: true
    },
    {
        Title: 'Email Templates',
        Description: 'Email Templates provide pre-designed formats for consistent and efficient communication, ensuring all customer emails follow a standard layout and tone.',
        ImgSrc: 'email-templates.png',
        IsNew: false,
        OrderNo: 9,
        IsActive: true
    },
    {
        Title: 'Email Notifications',
        Description: 'Email Notifications alert users to important updates, such as ticket status changes and responses, ensuring timely communication on support issues.',
        ImgSrc: 'notification.png',
        IsNew: false,
        OrderNo: 10,
        IsActive: true
    },
    {
        Title: 'Dark Mode',
        Description: 'Dark Mode offers a low-light interface option, reducing eye strain and providing a more comfortable viewing experience in low-light environments.',
        ImgSrc: 'dark-mode.png',
        IsNew: false,
        OrderNo: 11,
        IsActive: true
    },
    {
        Title: 'Global language support',
        Description: 'Global language support in Smart HelpDesk enhances accessibility by localizing ticket management and interface elements for a better user experience.',
        ImgSrc: 'translate.png',
        IsNew: false,
        OrderNo: 12,
        IsActive: true
    },
    {
        Title: 'Role Management',
        Description: 'Role management controls access by assigning permissions to user roles based on their responsibilities.',
        ImgSrc: 'role-management.png',
        IsNew: false,
        OrderNo: 13,
        IsActive: true
    },
    {
        Title: 'Custom Fields',
        Description: 'Custom fields allow users to add personalized data fields to forms, tickets, or records, enabling tailored information capture specific to their unique needs and workflows.',
        ImgSrc: 'custom-fields.png',
        IsNew: false,
        OrderNo: 14,
        IsActive: true
    },
];

export const HighlightsFeatures = [
    {
        Title: 'Email To Ticket',
        Description: `<li>Allows customers to submit support tickets by emailing the designated support address</li>
                                        <li>Automatically creates a ticket from the email in Smart HelpDesk</li>
                                        <li>Includes any email attachments as ticket attachments for comprehensive information capture</li>
                                        <li>Eliminates the need for customers to log into the application to create a ticket</li>
                                        <li>Saves time for both customers and support agents by simplifying the ticket submission process</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Femail-ticket.png?alt=media&token=7dceca6a-f7b4-4d67-9f6c-6f15f9280099',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Reports (Applications Analytics Reports)',
        Description: `<li>Smart HelpDesk offers a range of insightful reports, including Active/Inactive Users, ticket volume by status, ticket priority levels, knowledge base usage, and agent performance metrics.</li>
                      <li>These reports empower users to track essential metrics and gain a comprehensive view of their support operations.</li>
                      <li>By analyzing these reports, support teams can streamline processes, enhance customer satisfaction, and identify opportunities for improvement, helping them meet their performance goals effectively.</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Freport.png?alt=media&token=2d078a93-c36a-44e0-9801-7ca6418532eb',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Role Management (Roles and Permissions)',
        Description: `<li>Roles and Permissions in Smart HelpDesk define the level of access and control each team member has within the Smart HelpDesk system.</li>
                      <li>This feature ensures that team members have appropriate access based on their roles, enhancing security, streamlining workflows, and maintaining an organized support structure.</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Frole-management.png?alt=media&token=05865e6b-9e06-432f-8969-d7dd053c1e6d',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Custom Fields',
        Description: `<li>Custom Fields in Smart HelpDesk provide a powerful way for users to capture additional information about customers or support tickets beyond the default fields.</li>
                      <li>This feature enables users to track specific metrics, categorize tickets, and personalize support interactions for a tailored experience.</li>
                      <li>Users can select from various field types such as text, email, textarea, dropdown, radio buttons, and checkboxes and customize labels and options to suit their unique needs.</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Fcustom-fields.png?alt=media&token=edd38f8b-9656-4dba-a1c5-272b071104c4',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Email Templates',
        Description: `<li>Email Templates in Smart HelpDesk offer a versatile way to deliver efficient and personalized customer support.</li>
                      <li>These templates can be customized with dynamic fields like customer names, ticket numbers, and other relevant details, making them ideal for automated responses.</li>
                      <li>They’re also valuable for proactive communication, allowing teams to send updates or announcements seamlessly.</li>
                      <li>By using email templates, support teams can enhance efficiency, maintain consistent messaging, and improve overall customer engagement.</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Femail-templates.png?alt=media&token=498ca1aa-3fb8-45ee-ac5d-0ecec773c4a5',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
    {
        Title: 'Global language support',
        Description: `<li>The Smart HelpDesk software application includes a robust language translation feature that enables users to translate the entire application into their preferred language.</li>
                      <li>This comprehensive functionality covers all interface elements, buttons, labels, predefined ticket statuses, priorities, placeholders, and badges.</li>
                      <li>Supporting multiple languages, the application empowers companies to effectively serve a diverse global customer base.</li>
                      <li>The translation feature allows for easy customization to align with a company's branding and language preferences.</li>
                      <li>By enhancing accessibility, this feature significantly improves the customer experience, boosts satisfaction, and reduces communication barriers.</li>`,
        ImgSrc: 'https://firebasestorage.googleapis.com/v0/b/nextaspectsite.appspot.com/o/ProductDetails%2FSmart%20HelpDesk%2FFeatures%2Ftranslate.png?alt=media&token=75157673-e2f8-45d7-a736-90032ebe91ae',
        IsNew: false,
        OrderNo: 1,
        IsActive: true
    },
]